module.exports = __webpack_public_path__ + "img/marshall-shepherd.af6dc289.jpg";